import Colors from 'assets/Colors';
import { useNavigate } from 'react-router-dom';
import s from './styles';

function SideBarItem({ Icon, text, style, selected, path, setOpenSideBar }) {
  const navigate = useNavigate();

  return (
    <s.ItemWrapper
      style={style}
      selected={selected}
      onClick={() => {
        if (location.pathname !== path) {
          navigate(path);
        }
        setOpenSideBar && setOpenSideBar(true);
      }}
    >
      <s.IconWrapper selected={selected}>
        <Icon
          color={selected ? Colors.icon_on_secondary : Colors.icon_secondary}
        />
      </s.IconWrapper>
      <s.TextWrapper>{text}</s.TextWrapper>
    </s.ItemWrapper>
  );
}

export default SideBarItem;
